<template>
  <div class="bg-white min-h-screen">
    <!-- START HERO CONTENT -->
    <div class="bg-white px-3 hero-content py-20">
      <div class="">
        <p
          class="
            text-light-blue text-center
            uppercase
            text-lg
            font-semibold
            pb-10
          "
        >
          Efficient, End-to-End, FCRA Compliant
        </p>
        <h1 class="text-white text-center capitalize text-6xl py-5">
          The solution for your
        </h1>
        <h1 class="text-blue text-center capitalize text-6xl py-5">
          Real Estate Brokerage
        </h1>
        <h2
          class="text-white text-center text-base py-5 max-w-screen-sm mx-auto"
        >
          Click below to hear how Rent Application can provide the customized
          solution to streamline your agents’ workflow and reduce liability.
        </h2>
        <div class="w-full md:w-52 my-5 mx-auto">
          <PrimaryButton @click="contactUs">Contact Us</PrimaryButton>
        </div>
      </div>
    </div>

    <div class="px-3 py-8 md:py-20 md:px-8 bg-white">
      <div class="flex flex-col max-w-screen-md mx-auto">
        <div class="relative">
          <Lottie :animationData="animationData" />
          <div
            class="
              hidden
              md:block
              absolute
              right-0
              md:bottom-20
              flex flex-col
              bg-white
              w-2/3
            "
          >
            <h2 class="text-3xl md:text-4xl py-1">Intelligent routing</h2>
            <h2 class="text-3xl md:text-4xl py-1">
              with <span class="text-brand-blue">one click</span>
            </h2>
            <p class="py-2">
              Send applicants with ActiveLink™ directly via the platform or text
              message, or post it to your own site or MLS listing.
            </p>
          </div>
        </div>
        <div class="md:hidden flex flex-col px-3">
          <h2 class="text-3xl md:text-4xl py-1">Intelligent routing</h2>
          <h2 class="text-3xl md:text-4xl py-1">
            with <span class="text-brand-blue">one click</span>
          </h2>
          <p class="py-2">
            Send applicants with ActiveLink™ directly via the platform or text
            message, or post it to your own site or MLS listing.
          </p>
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="flex flex-col md:w-1/2 px-3 py-2">
            <h5 class="text-brand-blue py-2">01</h5>
            <h5 class="font-semibold py-1">
              Applicant completes application and pays
            </h5>
            <p class="py-1">
              Our smart routing automatically processes funds and deposits them
              into your account; orders reports and directs them to and notifies
              the correct agent.
            </p>
          </div>

          <div class="flex flex-col md:w-1/2 px-3 py-2">
            <h5 class="text-brand-blue py-2">02</h5>
            <h5 class="font-semibold py-1">
              Agents receive the reports to review with the client
            </h5>
            <p class="py-1">
              Agents can easily share applications and reports with clients.
              Applicants can be accepted or sent an adverse action letter within
              the platform. The application audit history is automatically
              tracked to reduce liability and support FCRA compliance.
            </p>
          </div>
        </div>
      </div>

      <h5
        class="
          my-5
          md:my-10
          text-base
          md:text-2xl
          text-brand-blue
          uppercase
          text-center
        "
      >
        Trusted by
      </h5>

      <div class="hidden md:block mx-auto max-w-screen-lg">
        <div class="my-16 flex flex-row justify-between">
          <img src="@/assets/images/remax.png" />
          <img src="@/assets/images/atproperties.png" />
          <img src="@/assets/images/related.png" />
          <img src="@/assets/images/realtor.png" />
        </div>
        <div class="my-8 flex flex-row justify-between">
          <img src="@/assets/images/keller.png" />
          <img src="@/assets/images/coldwell.png" />
          <img src="@/assets/images/berkshire.png" />
          <img class="max-h-16" src="@/assets/images/c21.png" />
          <img class="max-h-16" src="@/assets/images/sothebys.png" />
        </div>
      </div>

      <div class="block md:hidden mx-auto">
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/remax.png" />
          <img class="max-w-2/5" src="@/assets/images/atproperties.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/related.png" />
          <img class="max-w-2/5" src="@/assets/images/realtor.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/keller.png" />
          <img class="max-w-2/5" src="@/assets/images/coldwell.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/berkshire.png" />
          <img class="max-w-2/5 max-h-16" src="@/assets/images/c21.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5 max-h-16" src="@/assets/images/sothebys.png" />
        </div>
      </div>
    </div>
    <!-- END TRUST BY CONTENT -->

    <!-- START CONTROL CONTENT -->
    <div class="px-3 md:py-10 control-content">
      <div class="mx-auto max-w-screen-md py-10">
        <h2 class="text-5xl md:text-6xl text-center py-3">
          Advanced Permission Controls
        </h2>

        <p class="py-8 max-w-screen-sm text-center mx-auto">
          Customize employee, agent, and client perissions to match your
          company’s needs. Work with our dedicated team to match your agency’s
          rental application flow.
        </p>

        <div
          class="
            bg-white
            rounded
            py-3
            px-1
            md:py-10 md:px-10
            flex flex-col
            max-w-screen-sm
            mx-auto
          "
        >
          <div class="flex flex-row">
            <div class="flex items-center w-2/5"></div>

            <div class="flex items-center w-1/5">
              <h5 class="text-sm md:text-xl font-semibold">Manager</h5>
            </div>

            <div class="flex items-center w-1/5">
              <h5 class="text-sm md:text-xl font-semibold">Agents</h5>
            </div>

            <div class="flex items-center w-1/5">
              <h5 class="text-sm md:text-xl font-semibold">Client</h5>
            </div>
          </div>

          <div class="flex flex-row py-2">
            <div class="flex items-center w-2/5">
              <p class="px-2">Form Creation</p>
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>

            <div class="flex items-center w-1/5">
              <XIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-red" />
            </div>
          </div>

          <div class="flex flex-row py-2">
            <div class="flex items-center w-2/5">
              <p class="px-2">View Reports</p>
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>

            <div class="flex items-center w-1/5">
              <XIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-red" />
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>
          </div>

          <div class="flex flex-row py-2">
            <div class="flex items-center w-2/5">
              <p class="px-2">View App Payments</p>
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>

            <div class="flex items-center w-1/5">
              <XIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-red" />
            </div>

            <div class="flex items-center w-1/5">
              <XIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-red" />
            </div>
          </div>

          <div class="flex flex-row py-2">
            <div class="flex flex-col w-2/5">
              <p class="py-1 px-2">Decision Hub</p>
              <p class="px-2 text-3xs md:text-2xs italic text-brand-dark-gray">
                Selecting Applicant v. Adverse Action
              </p>
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>

            <div class="flex items-center w-1/5">
              <XIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-red" />
            </div>

            <div class="flex items-center w-1/5">
              <CheckIcon class="w-5 h-5 md:w-10 md:h-10 text-brand-blue" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- START CONTROL CONTENT -->

    <!-- START EMPLOYMENT PLUS CONTENT -->
    <div class="px-3 md:py-10">
      <div class="mx-auto max-w-screen-lg py-10">
        <div class="flex flex-col md:flex-row">
          <div class="flex items-center md:w-1/2 px-2">
            <img src="@/assets/images/employment-plus.png" class="w-4/5" />
          </div>

          <div class="flex flex-col justify-center md:w-1/2 px-2">
            <h2 class="text-5xl md:text-6xl py-2">Verified with</h2>
            <h2 class="text-5xl md:text-6xl py-2 text-brand-blue">
              Employment +
            </h2>
            <br />
            <p class="py-2">
              We use mutliple channels to confirm employment history and
              previous residences, verify income, and validate their company
              email address.
            </p>
            <p class="py-2">
              We text, call, email, and use our SecureCheck™ process to ensure
              that you are receiving the highest quality candidates.
            </p>
            <div class="md:w-1/2 py-5">
              <PrimaryButton @click="contactUs">Learn More</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END EMPLOYMENT PLUS CONTENT -->

    <!-- START COMPLIANCE ENGINE CONTENT -->
    <div class="px-3 md:py-10">
      <div class="mx-auto max-w-screen-lg py-10">
        <div class="flex flex-col md:flex-row">
          <div class="flex items-center md:w-1/3 md:mr-8 py-3">
            <img
              src="@/assets/images/brokerage-compliance-engine.png"
              class="w-4/5 md:w-full"
            />
          </div>

          <div class="flex flex-col justify-center md:w-2/3 px-2">
            <h2
              class="text-5xl md:text-6xl pt-2 text-brand-blue"
              style="line-height: 4rem"
            >
              Compliance Engine
            </h2>
            <h2 class="text-5xl md:text-6xl pb-2" style="line-height: 4rem">
              powered by Decision Hub
            </h2>
            <br />
            <p class="py-2">
              Stay FCRA compliant with the Rent Application Compliance Engine.
              We automatically audit actions taken for each application and
              track whether or not you can view reports based on your location.
            </p>
            <p class="py-2">
              When it comes time to make a decision on for an applicant, use the
              Decision Hub to abide Federal laws and automatically send adverse
              action letters.
            </p>
            <div class="md:w-1/2 py-5">
              <PrimaryButton @click="contactUs">Learn More</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END COMPLIANCE ENGINE CONTENT -->

    <!-- START CHARGE YOUR FEES CONTENT -->
    <div class="px-3 md:py-10">
      <div class="mx-auto max-w-screen-lg py-10">
        <div class="flex flex-col-reverse md:flex-row">
          <div class="flex flex-col justify-center md:w-1/2 px-2 md:mr-8">
            <h2 class="text-5xl md:text-6xl py-2">
              Charge your <br />own fees
            </h2>

            <br />
            <p class="py-2">Set your own additional rental application fee.</p>
            <p class="py-2">
              View and manage the fees you collect among all of your agents and
              receive hassle-free, automatic transfers to your bank account each
              month.
            </p>
            <div class="md:w-1/2 py-5">
              <PrimaryButton @click="contactUs">Contact Us</PrimaryButton>
            </div>
          </div>

          <div class="flex items-center md:w-1/2 px-2">
            <img src="@/assets/images/brokerage-fee.png" class="w-4/5" />
          </div>
        </div>
      </div>
    </div>
    <!-- END CHARGE YOUR FEES CONTENT -->

    <!-- START CONCIERGE CONTENT -->
    <div class="px-3 md:py-10">
      <div class="mx-auto max-w-screen-lg py-10">
        <div class="flex flex-col md:flex-row">
          <div class="flex items-center md:w-1/2 px-2 md:mr-8 py-3">
            <img src="@/assets/images/brokerage-concierge.png" class="w-4/5" />
          </div>

          <div class="flex flex-col justify-center md:w-1/2 px-2">
            <h2 class="text-5xl md:text-6xl py-1">Concierge guided</h2>
            <h2 class="text-5xl md:text-6xl py-1">customized setup</h2>

            <br />
            <p class="py-2">
              A dedicated onboarding specialist will review your needs and work
              with you to get your company accepting applications as quickly as
              possible.
            </p>

            <div class="md:w-1/2 py-5">
              <PrimaryButton @click="contactUs">Contact Us</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END CONCIERGE CONTENT -->

    <!-- START ELIMINATE CONTENT -->
    <div class="px-3 md:py-10 eliminate-content">
      <div class="mx-auto max-w-screen-md py-10">
        <h2 class="text-5xl md:text-6xl py-3 text-white">
          Eliminate roadblocks
        </h2>

        <p class="py-2 text-white">
          Rent Application removes the traditional wait for reports to process,
          allowing you to increase productivity. Reports can be accessed
          anytime, 7 days a week. With a dedicated support team, your agents
          have the resources they need at all times.
        </p>

        <div class="flex flex-col md:flex-row justify-between py-5">
          <div class="flex flex-col px-3 py-2">
            <h2 class="text-2xl md:text-4xl py-2 text-white">5 minutes</h2>
            <p class="text-white text-sm py-2">
              90% of reports processed in under 5 minutes
            </p>
          </div>

          <div class="flex flex-col px-3 py-2">
            <h2 class="text-2xl md:text-4xl py-2 text-white">7 days</h2>
            <p class="text-white text-sm md:py-2">
              US based Support staff ready and willing to help
            </p>
          </div>

          <div class="flex flex-col px-3 py-2">
            <h2 class="text-2xl md:text-4xl py-2 text-white">$0 / mo.</h2>
            <p class="text-white text-sm md:py-2">
              Rent Application is FREE! No hidden fees.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- END ELIMINATE CONTENT -->

    <!-- START CRM CONTENT -->
    <div class="px-3 md:py-10">
      <div class="mx-auto max-w-screen-lg py-10">
        <div class="flex flex-col md:flex-row">
          <div class="flex flex-col justify-center md:w-full px-2">
            <h2 class="text-5xl md:text-6xl py-2">
              Want to sync with your CRM?
            </h2>
            <h2 class="text-5xl md:text-6xl py-2">Need portal integration?</h2>
            <h2 class="text-5xl md:text-6xl py-2 text-brand-blue">
              Have software you love?
            </h2>
            <h2 class="text-5xl md:text-6xl py-2 text-brand-blue">
              We can integrate!
            </h2>
            <br />
            <p class="py-2 md:w-2/3">
              With Brokerage Premium, we can customize our platform to create a
              seamless experience for your applicants. Contact us to discuss how
              we can further help grow your business.
            </p>

            <div class="md:w-1/4 py-5">
              <PrimaryButton @click="contactUs">Contact Us</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END CRM CONTENT -->
  </div>
  <Footer />
</template>
<script>
import { CheckIcon, XIcon } from "@heroicons/vue/outline"

import PhoneGif from "@/assets/animations/phone_w_flow.json"

export default {
  components: {
    CheckIcon,
    XIcon
  },
  data() {
    return {
      animationData: PhoneGif
    }
  },
  methods: {
    contactUs() {
      location.href = "https://contact.rentapp.net/"
    }
  }
}
</script>
<style lang="scss" scoped>
.gray-background {
  background: #f9f9fb;
}

.text-light-blue {
  color: #789afe;
}
.text-blue {
  color: #4f76e7;
}
.hero-content,
.eliminate-content {
  background-image: url("~@/assets/images/brokerage-hero-background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.control-content {
  background: url("~@/assets/images/brokerage-control-background.png") center
    center no-repeat;
  background-size: cover;
}
</style>
